import {gsap} from "../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class OpenWater extends PIXI.Container {

  constructor() {
    super();

    this.shown = false;
    this.side = "right";

    this.revealRow = 8; // if we reach this row, reveal happens

    // If we touch these tiles, reveal happens (aka we are 2 cells away)
    this.revealTiles = {
      right: [
        {row: 9, col: 6},
        {row: 9, col: 7},
        {row: 9, col: 8},
        {row: 10, col: 8}
      ],
      left: [
        {row: 9, col: 0},
        {row: 9, col: 1},
        {row: 9, col: 2},
        {row: 10, col: 0}
      ]
    };

    this.build();
  }

  build() {
    this.position.set(2160, 1470);

    this.sprite = new PIXI.Sprite(app.game.assets["open-water"]);
    this.sprite.anchor.set(1, 0);
    this.sprite.texture.source.resource.loop = true;
    this.sprite.alpha = 0;

    this.cloudsSprite = new PIXI.Sprite(app.game.assets["open-water-clouds"]);
    this.cloudsSprite.anchor.set(1, 0);
    this.cloudsSprite.position.set(0, -50);
    this.cloudsSprite.texture.source.resource.loop = true;

    this.addChild(this.sprite, this.cloudsSprite);
  }

  setPosition(side = "right") {
    if (side == "right") {
      this.position.x = 2160;
      this.scale.x = 1;
    } else if (side == "left") {
      this.position.x = 0;
      this.scale.x = -1;
    }

    this.side = side;
  }

  endOfTurnAction() {

    if (!this.shown) {
      if (app.game.player.currentTile.rowIndex <= this.revealRow) {
        // if we are on the same row as the start of the water, reveal it
        this.reveal();
      } else {
        // Check to see if we are on a reveal tile
        for (let i = 0; i < this.revealTiles[this.side].length; i++) {
          const revealTile = this.revealTiles[this.side][i];

          if (app.game.player.currentTile.rowIndex == revealTile.row && app.game.player.currentTile.colIndex == revealTile.col) {
            this.reveal();
            break;
          }
        }
      }
    }

  }

  reveal() {
    this.shown = true;

    // Crossfade water and clouds
    gsap.to(this.sprite, {
      pixi: {
        alpha: 1
      },
      duration: 2,
      ease: "power1.inOut",
    })

    gsap.to(this.cloudsSprite, {
      pixi: {
        alpha: 0
      },
      duration: 2,
      ease: "power1.inOut",
    })

  }

  playVideo(){
    this.sprite.texture.source.resource.play();
    this.cloudsSprite.texture.source.resource.play();
  }

  pauseVideo(){
    this.sprite.texture.source.resource.pause();
    this.cloudsSprite.texture.source.resource.pause();
  }

  reset() {
    this.shown = false;
    this.cloudsSprite.alpha = 1;
    this.sprite.alpha = 0;
    this.playVideo(); // Make sure we trigger play so the video is really playing correctly
  }


}
